<template>
  <section class="dp-layout parking-page access-record-page">
    <section class="dp-right">
      <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <div class="parking-stat-wrap">
      <div class="parking-stat-cards" :class="{ 'is-summary-loading': summaryLoading }">
        <div class="parking-stat-card stat-total clickable" :class="{ active: searchRecordType === 0 }" @click="quickFilterByType(0)">
          <div class="stat-card-head">
            <span class="stat-card-icon"><i class="el-icon-s-data"></i></span>
            <span class="stat-card-label">总记录</span>
          </div>
          <div class="stat-card-value">{{ summary.totalCount }}</div>
        </div>
        <div class="parking-stat-card stat-entry clickable" :class="{ active: searchRecordType === 1 }" @click="quickFilterByType(1)">
          <div class="stat-card-head">
            <span class="stat-card-icon"><i class="el-icon-bottom-right"></i></span>
            <span class="stat-card-label">入场</span>
          </div>
          <div class="stat-card-value">{{ summary.entryCount }}</div>
        </div>
        <div class="parking-stat-card stat-exit clickable" :class="{ active: searchRecordType === 2 }" @click="quickFilterByType(2)">
          <div class="stat-card-head">
            <span class="stat-card-icon"><i class="el-icon-top-right"></i></span>
            <span class="stat-card-label">出场</span>
          </div>
          <div class="stat-card-value">{{ summary.exitCount }}</div>
        </div>
        <div class="parking-stat-card stat-plates">
          <div class="stat-card-head">
            <span class="stat-card-icon"><i class="el-icon-truck"></i></span>
            <span class="stat-card-label">
              不同车牌
              <el-tooltip content="当前筛选时间范围内，按车牌去重后的车辆数。同一辆车进出多次只计 1 辆。" placement="top">
                <i class="el-icon-question stat-tip-icon"></i>
              </el-tooltip>
            </span>
          </div>
          <div class="stat-card-value">{{ summary.uniquePlateCount }}</div>
        </div>
        <div class="parking-stat-card stat-duration">
          <div class="stat-card-head">
            <span class="stat-card-icon"><i class="el-icon-time"></i></span>
            <span class="stat-card-label">
              平均停车
              <el-tooltip content="仅统计出场记录的停车时长平均值。" placement="top">
                <i class="el-icon-question stat-tip-icon"></i>
              </el-tooltip>
            </span>
          </div>
          <div class="stat-card-value is-text">{{ avgDurationText }}</div>
        </div>
      </div>
      </div>

      <div class="parking-table-panel">
        <div class="panel-header">
          <div class="panel-title">进出记录<span class="count">共 {{ total }} 条 · {{ scopeTextShort }}</span></div>
        </div>

        <div class="tbl-scroll-host">
        <el-table
          :data="tableData"
          v-loading="listLoading"
          class="custom-tbl"
          style="width:100%"
          height="100%"
        >
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column prop="recordTypeName" label="类型" width="80">
            <template slot-scope="scope">
              <el-tag :type="scope.row.recordType === 1 ? 'success' : 'warning'" size="small">
                {{ scope.row.recordTypeName }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="plateNo" label="车牌号" width="130">
            <template slot-scope="scope">
              <span class="plate-no-badge">{{ scope.row.plateNo }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="ownerName" label="车主姓名" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.ownerName">{{ scope.row.ownerName }}</span>
              <span v-else class="text-muted">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="inTime" label="进场时间" width="170">
            <template slot-scope="scope">
              <span v-if="scope.row.recordType === 1" class="time-text">
                {{ formatDate(scope.row.eventTime) }}
              </span>
              <span v-else class="time-text">
                {{ formatDate(scope.row.inTime) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="outTime" label="出场时间" width="170">
            <template slot-scope="scope">
              <span v-if="scope.row.recordType === 2" class="time-text">
                {{ formatDate(scope.row.eventTime) }}
              </span>
              <span v-else class="text-muted">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="durationMinutes" label="停车时长" width="110">
            <template slot-scope="scope">
              <span v-if="scope.row.durationMinutes != null" class="duration-badge">
                <i class="el-icon-time"></i> {{ formatDuration(scope.row.durationMinutes) }}
              </span>
              <span v-else class="text-muted">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="vehicleCategory" label="车辆类别" width="130">
            <template slot-scope="scope">
              <span v-if="scope.row.vehicleCategory" class="category-tag">
                {{ scope.row.vehicleCategory }}
              </span>
              <span v-else class="text-muted">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="channelId" label="通道" width="160">
            <template slot-scope="scope">
              <div v-if="scope.row.channelId && scope.row.channelId.includes('->')" class="channel-flow">
                <div class="channel-item in">
                  <span class="label-in">进</span>
                  <span class="name">{{ scope.row.channelId.split('->')[0].trim() }}</span>
                </div>
                <div class="channel-item out">
                  <span class="label-out">出</span>
                  <span class="name">{{ scope.row.channelId.split('->')[1].trim() }}</span>
                </div>
              </div>
              <div v-else-if="scope.row.channelId" class="channel-item single">
                <span :class="['label-single', scope.row.recordType === 1 ? 'in' : 'out']">
                  {{ scope.row.recordType === 1 ? '进' : '出' }}
                </span>
                <span class="name">{{ scope.row.channelId }}</span>
              </div>
              <span v-else class="text-muted">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="picUrl" label="抓拍图" width="160">
            <template slot-scope="scope">
              <div v-if="scope.row.picUrl" class="image-preview-group">
                <div
                  v-for="(url, idx) in showImage(scope.row.picUrl)"
                  :key="idx"
                  class="image-item"
                >
                  <oss-el-image
                    :src="url"
                    :school-id="schoolId"
                    :preview-src-list="showImage(scope.row.picUrl)"
                    fit="cover"
                    class="record-img"
                  >
                    <div slot="error" class="image-error-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </oss-el-image>
                  <span class="image-tag">{{ getPicTag(scope.row, idx) }}</span>
                </div>
              </div>
              <span v-else class="text-muted">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="系统记录时间" min-width="160">
            <template slot-scope="scope">{{ formatDate(scope.row.createTime) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openDetail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        </div>

        <el-col :span="24" class="toolbar">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="page"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            style="float:right"
          ></el-pagination>
        </el-col>
      </div>
    </section>

    <parking-external-pic-migrate-dialog
      :visible.sync="migrateDialogVisible"
      :school-id="schoolId"
      @done="onMigrateDone"
    />

    <el-dialog
      title="进出记录详情"
      :visible.sync="detailVisible"
      width="820px"
      top="6vh"
      append-to-body
      :close-on-click-modal="false"
    >
      <div v-loading="detailLoading">
        <template v-if="detail">
          <el-alert
            v-if="detail.remark"
            :title="detail.remark"
            type="warning"
            :closable="false"
            show-icon
            class="detail-remark-alert"
          />
          <el-descriptions :column="2" border size="small" class="detail-desc">
            <el-descriptions-item label="类型">
              <el-tag :type="detail.recordType === 1 ? 'success' : 'warning'" size="mini">
                {{ detail.recordTypeName }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="车牌号">{{ detail.plateNo || '-' }}</el-descriptions-item>
            <el-descriptions-item label="车主">{{ detail.ownerName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="车辆类别">{{ detail.vehicleCategory || '-' }}</el-descriptions-item>
            <el-descriptions-item label="进场时间">{{ formatDate(detail.inTimeDisplay) || '-' }}</el-descriptions-item>
            <el-descriptions-item label="出场时间">{{ formatDate(detail.outTimeDisplay) || '-' }}</el-descriptions-item>
            <el-descriptions-item label="停车时长">{{ detail.durationText || '-' }}</el-descriptions-item>
            <el-descriptions-item label="通道">{{ detail.channelId || '-' }}</el-descriptions-item>
            <el-descriptions-item label="车牌颜色">{{ detail.licenseColorName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="订单号">{{ detail.orderId || '-' }}</el-descriptions-item>
            <el-descriptions-item label="车场编号">{{ detail.parkId || '-' }}</el-descriptions-item>
            <el-descriptions-item label="出场标记">{{ detail.flagName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="事件类型码">{{ detail.parkEventType != null ? detail.parkEventType : '-' }}</el-descriptions-item>
            <el-descriptions-item label="系统记录时间" :span="2">{{ formatDate(detail.createTime) || '-' }}</el-descriptions-item>
            <el-descriptions-item label="厂家备注" :span="2">{{ detail.remark || '-' }}</el-descriptions-item>
          </el-descriptions>

          <div class="detail-pics" v-if="detail.picUrls && detail.picUrls.length">
            <div class="detail-pics-title">抓拍图</div>
            <div class="detail-pics-row">
              <div v-for="(url, idx) in detail.picUrls" :key="idx" class="detail-pic-item">
                <oss-el-image
                  :src="url"
                  :school-id="schoolId"
                  :preview-src-list="detail.picUrls"
                  fit="cover"
                  class="detail-pic"
                >
                  <div slot="error" class="image-error-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </oss-el-image>
                <span class="image-tag">{{ getPicTag(detail, idx) }}</span>
              </div>
            </div>
          </div>

          <div v-if="detail.rawJson" class="detail-raw" :class="{ 'is-expanded': detailRawExpanded }">
            <div class="detail-raw-head" @click="detailRawExpanded = !detailRawExpanded">
              <span class="detail-raw-title">
                <i :class="detailRawExpanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                原始推送 JSON
              </span>
              <el-button
                type="text"
                size="mini"
                icon="el-icon-document-copy"
                @click.stop="copyRawJson"
              >复制</el-button>
            </div>
            <pre v-show="detailRawExpanded" class="detail-raw-pre" v-html="detail.rawJsonHtml"></pre>
          </div>
        </template>
      </div>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import Toolbar from '@/components/Toolbar'
import ParkingExternalPicMigrateDialog from './ParkingExternalPicMigrateDialog.vue'
import {
  getParkingAccessRecordPage,
  getParkingAccessRecordSummary,
  exportParkingAccessRecord,
  getParkingAccessRecordDetail
} from '@/api/parking'
import { loadButtonFuncs, buildToolbarButtons } from './parkingUtils'

const TOOLBAR_BUTTONS = [
  { name: '查询', Func: 'handleSearchBtn', icon: 'el-icon-search', always: true },
  { name: '导出', Func: 'handleExport', icon: 'el-icon-download', btnType: 'default' },
  { name: '迁移厂家图片', Func: 'openMigrateDialog', icon: 'el-icon-upload2', btnType: 'warning' }
]

export default {
  name: 'ParkingAccessRecord',
  components: { Toolbar, ParkingExternalPicMigrateDialog },
  data() {
    const now = new Date()
    const pad = n => String(n).padStart(2, '0')
    const dateStr = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
    const defaultStartTime = `${dateStr} 00:00:00`
    const defaultEndTime = `${dateStr} 23:59:59`

    return {
      schoolId: null,
      migrateDialogVisible: false,
      detailVisible: false,
      detailLoading: false,
      detail: null,
      detailRawExpanded: false,
      listLoading: false,
      summaryLoading: false,
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 10,
      pageSizes: [10, 20, 50, 100, 200],
      searchPlateNo: '',
      searchRecordType: 0,
      searchStartTime: defaultStartTime,
      searchEndTime: defaultEndTime,
      summary: {
        totalCount: 0,
        entryCount: 0,
        exitCount: 0,
        uniquePlateCount: 0,
        avgDurationMinutes: null
      },
      buttonList: [],
      searchList: [
        { key: 'searchPlateNo', label: '车牌号', width: '132px' },
        {
          key: 'searchRecordType', label: '记录类型', type: 'select', clearable: true, initValue: 0, width: '108px',
          options: [
            { value: 0, label: '全部' },
            { value: 1, label: '入场' },
            { value: 2, label: '出场' }
          ]
        },
        { key: 'searchStartTime', label: '开始时间', type: 'datetime', initValue: defaultStartTime, width: '196px' },
        { key: 'searchEndTime', label: '结束时间', type: 'datetime', initValue: defaultEndTime, width: '196px' }
      ]
    }
  },
  computed: {
    scopeText() {
      const start = this.searchStartTime ? this.formatDate(this.searchStartTime) : '不限'
      const end = this.searchEndTime ? this.formatDate(this.searchEndTime) : '不限'
      return `${start} ~ ${end}`
    },
    scopeTextShort() {
      const fmt = val => {
        if (!val) return '不限'
        const d = new Date(val)
        if (isNaN(d.getTime())) return val
        const pad = n => String(n).padStart(2, '0')
        return `${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
      }
      return `${fmt(this.searchStartTime)} ~ ${fmt(this.searchEndTime)}`
    },
    avgDurationText() {
      if (this.summary.avgDurationMinutes == null) return '-'
      return this.formatDuration(this.summary.avgDurationMinutes)
    }
  },
  watch: {
    '$store.state.activeSchoolId': {
      handler(newVal) {
        if (newVal) {
          this.schoolId = newVal
          this.page = 1
          this.loadData()
        }
      },
      immediate: true
    }
  },
  created() {
    this.buttonList = buildToolbarButtons(TOOLBAR_BUTTONS, loadButtonFuncs(this.$route.path))
  },
  methods: {
    callFunction(item) {
      if (item.Func && typeof this[item.Func] === 'function') {
        this[item.Func](item)
        return
      }
      if (item.search) {
        this.handleSearchBtn(item)
      }
    },
    /** 打开厂家抓拍图迁移弹窗 */
    openMigrateDialog() {
      if (!this.schoolId) {
        this.$message.warning('请先选择学校')
        return
      }
      this.migrateDialogVisible = true
    },
    /** 打开进出记录详情 */
    async openDetail(row) {
      if (!this.schoolId || !row || !row.id) return
      this.detailVisible = true
      this.detailLoading = true
      this.detailRawExpanded = false
      this.detail = null
      try {
        const res = await getParkingAccessRecordDetail({
          schoolId: this.schoolId,
          id: row.id
        })
        if (!res.data || !res.data.success) {
          this.$message.error((res.data && res.data.msg) || '加载详情失败')
          return
        }
        const r = res.data.response || {}
        const recordType = r.RecordType != null ? r.RecordType : r.recordType
        const eventTime = r.EventTime || r.eventTime
        const inTime = r.InTime || r.inTime
        const durationMinutes = r.DurationMinutes != null ? r.DurationMinutes : r.durationMinutes
        const picUrl = r.PicUrl || r.picUrl || ''
        const rawJson = r.RawJson || r.rawJson || ''
        let rawJsonPretty = rawJson
        try {
          if (rawJson) rawJsonPretty = JSON.stringify(JSON.parse(rawJson), null, 2)
        } catch (e) { /* keep raw */ }

        this.detail = {
          id: r.Id || r.id,
          recordType,
          recordTypeName: r.RecordTypeName || r.recordTypeName || (recordType === 1 ? '入场' : '出场'),
          plateNo: r.PlateNo || r.plateNo || '',
          ownerName: r.OwnerName || r.ownerName || '',
          eventTime,
          inTime,
          inTimeDisplay: recordType === 1 ? eventTime : inTime,
          outTimeDisplay: recordType === 2 ? eventTime : null,
          durationMinutes,
          durationText: durationMinutes != null ? this.formatDuration(durationMinutes) : '',
          vehicleCategory: r.VehicleCategory || r.vehicleCategory || '',
          channelId: r.ChannelId || r.channelId || '',
          picUrl,
          picUrls: this.showImage(picUrl),
          createTime: r.CreateTime || r.createTime || '',
          parkId: r.ParkId || r.parkId || '',
          orderId: r.OrderId || r.orderId || '',
          licenseColorName: r.LicenseColorName || r.licenseColorName || '',
          remark: r.Remark || r.remark || '',
          flagName: r.FlagName || r.flagName || '',
          parkEventType: r.ParkEventType != null ? r.ParkEventType : r.parkEventType,
          rawJson,
          rawJsonPretty,
          rawJsonHtml: this.formatJsonHtml(rawJsonPretty)
        }
      } catch (e) {
        this.$message.error('加载详情失败')
      } finally {
        this.detailLoading = false
      }
    },
    /** 迁移完成后刷新列表 */
    onMigrateDone() {
      this.loadData()
    },
    handleSearchBtn(item) {
      const s = item.search || {}
      const prevPlate = this.searchPlateNo
      const prevStart = this.searchStartTime
      const prevEnd = this.searchEndTime
      this.searchPlateNo = s.searchPlateNo || ''
      const rawType = s.searchRecordType
      this.searchRecordType = (rawType === '' || rawType == null) ? 0 : rawType
      this.searchStartTime = s.searchStartTime || null
      this.searchEndTime = s.searchEndTime || null
      this.page = 1
      const summaryScopeChanged = prevPlate !== this.searchPlateNo
        || prevStart !== this.searchStartTime
        || prevEnd !== this.searchEndTime
      if (summaryScopeChanged) {
        this.loadSummary()
      }
      this.loadList()
    },
    buildFilterParams() {
      const params = { schoolId: this.schoolId }
      if (this.searchPlateNo) params.plateNo = this.searchPlateNo
      const recordType = this.searchRecordType
      if (recordType !== '' && recordType != null && recordType > 0) {
        params.recordType = recordType
      }
      if (this.searchStartTime) params.startTime = this.searchStartTime
      if (this.searchEndTime) params.endTime = this.searchEndTime
      return params
    },
    /** 汇总参数：不含记录类型，卡片始终展示全量分布 */
    buildSummaryParams() {
      const params = { schoolId: this.schoolId }
      if (this.searchPlateNo) params.plateNo = this.searchPlateNo
      if (this.searchStartTime) params.startTime = this.searchStartTime
      if (this.searchEndTime) params.endTime = this.searchEndTime
      return params
    },
    async loadData() {
      if (!this.schoolId) return
      await Promise.all([this.loadSummary(), this.loadList()])
    },
    async loadSummary() {
      if (!this.schoolId) return
      this.summaryLoading = true
      try {
        const res = await getParkingAccessRecordSummary(this.buildSummaryParams())
        if (res.data && res.data.success) {
          const r = res.data.response || {}
          this.summary = {
            totalCount: r.TotalCount != null ? r.TotalCount : (r.totalCount || 0),
            entryCount: r.EntryCount != null ? r.EntryCount : (r.entryCount || 0),
            exitCount: r.ExitCount != null ? r.ExitCount : (r.exitCount || 0),
            uniquePlateCount: r.UniquePlateCount != null ? r.UniquePlateCount : (r.uniquePlateCount || 0),
            avgDurationMinutes: r.AvgDurationMinutes != null ? r.AvgDurationMinutes : r.avgDurationMinutes
          }
        }
      } catch (e) {
        // 汇总失败不阻断列表
      } finally {
        this.summaryLoading = false
      }
    },
    async loadList() {
      if (!this.schoolId) return
      this.listLoading = true
      try {
        const res = await getParkingAccessRecordPage({
          ...this.buildFilterParams(),
          page: this.page,
          pageSize: this.pageSize
        })
        if (res.data && res.data.success) {
          const resp = res.data.response || {}
          this.tableData = (resp.data || []).map(r => ({
            id: r.Id || r.id,
            recordType: r.RecordType != null ? r.RecordType : r.recordType,
            recordTypeName: r.RecordTypeName || r.recordTypeName || '',
            plateNo: r.PlateNo || r.plateNo || '',
            ownerName: r.OwnerName || r.ownerName || '',
            eventTime: r.EventTime || r.eventTime || '',
            inTime: r.InTime || r.inTime || null,
            durationMinutes: r.DurationMinutes != null ? r.DurationMinutes : r.durationMinutes,
            vehicleCategory: r.VehicleCategory || r.vehicleCategory || '',
            channelId: r.ChannelId || r.channelId || '',
            picUrl: r.PicUrl || r.picUrl || '',
            createTime: r.CreateTime || r.createTime || ''
          }))
          this.total = resp.dataCount || resp.DataCount || 0
        }
      } catch (e) {
        this.$message.error('加载失败')
      } finally {
        this.listLoading = false
      }
    },
    quickFilterByType(type) {
      if (this.searchRecordType === type) return
      this.searchRecordType = type
      this.page = 1
      this.syncToolbarRecordType(type)
      this.loadList()
    },
    syncToolbarRecordType(type) {
      const toolbar = this.$refs.toolbar
      if (!toolbar || !toolbar.searchObj) return
      toolbar.searchObj.searchRecordType = type
    },
    async handleExport() {
      if (!this.schoolId) {
        this.$message.warning('请先选择学校')
        return
      }
      try {
        const res = await exportParkingAccessRecord(this.buildFilterParams())
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `进出记录_${this.formatDateShort()}.xlsx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      } catch (e) {
        this.$message.error('导出失败')
      }
    },
    formatDateShort() {
      const d = new Date()
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}`
    },
    handleCurrentChange(val) {
      this.page = val
      this.loadList()
    },
    handleSizeChange(val) {
      this.pageSize = Math.min(val, 200)
      this.page = 1
      this.loadList()
    },
    formatDate(val) {
      if (!val) return ''
      const d = new Date(val)
      if (isNaN(d.getTime())) return val
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    formatDuration(minutes) {
      if (!minutes && minutes !== 0) return ''
      const h = Math.floor(minutes / 60)
      const m = minutes % 60
      if (h > 0) return `${h}时${m}分`
      return `${m}分`
    },
    /**
     * JSON 简易高亮（转义后着色）
     */
    formatJsonHtml(text) {
      if (!text) return ''
      const escaped = String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
      return escaped
        .replace(/("(?:\\.|[^"\\])*")(\s*:)/g, '<span class="json-key">$1</span>$2')
        .replace(/:\s*("(?:\\.|[^"\\])*")/g, ': <span class="json-str">$1</span>')
        .replace(/:\s*(-?\d+(?:\.\d+)?)/g, ': <span class="json-num">$1</span>')
        .replace(/:\s*(true|false|null)\b/g, ': <span class="json-lit">$1</span>')
    },
    /** 复制原始 JSON */
    copyRawJson() {
      const text = (this.detail && (this.detail.rawJsonPretty || this.detail.rawJson)) || ''
      if (!text) return
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success('已复制')
        }).catch(() => {
          this.$message.error('复制失败')
        })
        return
      }
      const ta = document.createElement('textarea')
      ta.value = text
      document.body.appendChild(ta)
      ta.select()
      try {
        document.execCommand('copy')
        this.$message.success('已复制')
      } catch (e) {
        this.$message.error('复制失败')
      }
      document.body.removeChild(ta)
    },
    /**
     * 抓拍图角标。优先级：
     * 1) URL 含 /in/ 或 /out/
     * 2) 多图（历史合并 PicUrl 分号拼接）：第 1 张进、其后出
     * 3) 单图：按记录类型（入场=进，出场=出）
     */
    getPicTag(row, idx) {
      const urls = this.showImage(row && row.picUrl)
      const url = (urls[idx] || '').toLowerCase()
      if (url.includes('/out/')) return '出'
      if (url.includes('/in/')) return '进'
      if (urls.length >= 2) return idx === 0 ? '进' : '出'
      return row && row.recordType === 1 ? '进' : '出'
    }
  }
}
</script>

<style>
@import './parking-page.css';

/* 进出记录页局部样式（通用布局见 parking-page.css） */

.access-record-page .duration-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #0d9488;
  background-color: #f0fdfa;
  border: 1px solid #ccfbf1;
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.access-record-page .duration-badge i {
  font-size: 13px;
}

.access-record-page .category-tag {
  display: inline-block;
  font-size: 11px;
  color: #4f46e5;
  background-color: #eef2ff;
  border: 1px solid #e0e7ff;
  padding: 2px 8px;
  border-radius: 20px;
  font-weight: 500;
}

.access-record-page .channel-flow {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-start;
}

.access-record-page .channel-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
}

.access-record-page .channel-item.in .label-in {
  display: inline-block;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  background: linear-gradient(135deg, #4ade80 0%, #22c55e 100%);
  color: #ffffff;
  font-size: 10px;
  font-weight: bold;
  border-radius: 4px;
}

.access-record-page .channel-item.out .label-out {
  display: inline-block;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  background: linear-gradient(135deg, #fb923c 0%, #f97316 100%);
  color: #ffffff;
  font-size: 10px;
  font-weight: bold;
  border-radius: 4px;
}

.access-record-page .channel-item .name {
  color: #334155;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.access-record-page .channel-item.single .label-single {
  display: inline-block;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  color: #ffffff;
  font-size: 10px;
  font-weight: bold;
  border-radius: 4px;
}

.access-record-page .channel-item.single .label-single.in {
  background: linear-gradient(135deg, #4ade80 0%, #22c55e 100%);
}

.access-record-page .channel-item.single .label-single.out {
  background: linear-gradient(135deg, #fb923c 0%, #f97316 100%);
}

.access-record-page .image-preview-group {
  display: flex;
  gap: 8px;
  align-items: center;
}

.access-record-page .image-item {
  position: relative;
  width: 60px !important;
  height: 40px !important;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  cursor: pointer;
}

.access-record-page .image-item:hover {
  transform: translateY(-2px) scale(1.06);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.12);
  z-index: 10;
}

.access-record-page .record-img {
  width: 60px !important;
  height: 40px !important;
  display: block;
}

.access-record-page .image-error-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 40px;
  background-color: #f1f5f9;
  color: #94a3b8;
  font-size: 16px;
}

.access-record-page .image-tag {
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: rgba(15, 23, 42, 0.75);
  color: #ffffff;
  font-size: 9px;
  padding: 0 4px;
  border-top-left-radius: 3px;
  line-height: 14px;
  z-index: 2;
  pointer-events: none;
}

.detail-remark-alert {
  margin-bottom: 20px !important;
}

.detail-desc {
  margin-bottom: 12px;
}

.detail-pics {
  margin: 16px 0 0;
}

.detail-pics-title {
  font-size: 13px;
  color: #606266;
  margin-bottom: 8px;
  font-weight: 600;
}

.detail-pics-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.detail-pic-item {
  position: relative;
  width: 120px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.detail-pic {
  width: 120px !important;
  height: 80px !important;
  display: block;
}

.detail-raw {
  margin-top: 20px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: #0f172a;
}

.detail-raw-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #1e293b;
  border-bottom: 1px solid transparent;
  cursor: pointer;
  user-select: none;
}

.detail-raw.is-expanded .detail-raw-head {
  border-bottom-color: #334155;
}

.detail-raw-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #e2e8f0;
}

.detail-raw-head .el-button {
  color: #93c5fd;
  padding: 0;
}

.detail-raw-pre {
  margin: 0;
  max-height: 320px;
  overflow: auto;
  font-size: 12px;
  line-height: 1.55;
  font-family: Consolas, Monaco, 'Courier New', monospace;
  white-space: pre;
  word-break: normal;
  background: #0f172a;
  color: #cbd5e1;
  padding: 14px 16px;
}

.detail-raw-pre .json-key {
  color: #7dd3fc;
}

.detail-raw-pre .json-str {
  color: #86efac;
}

.detail-raw-pre .json-num {
  color: #fcd34d;
}

.detail-raw-pre .json-lit {
  color: #f9a8d4;
}
</style>
